import React from "react";
import { useNavigate } from "react-router-dom";
import "./AlertPopUp.css";

const AlertPopUp = ({ open, title, message, closeButtonText, buttonText, navigateTo, onAction, onClose }) => {
    const navigate = useNavigate();
    if (!open) return null;

    const handleClick = () => {
        if (onAction) {
            onAction();
        }

        if (navigateTo) {
            navigate(navigateTo);
        }

        onClose?.(); // close popup after action
    };

    return (
        <div className="nav-popup-overlay">
            <div className="nav-popup">
                <h3>{title}</h3>
                <p>{message}</p>
                {closeButtonText && (
                    <button className="nav-popup-btn_cancle" onClick={() => onClose?.()}>{closeButtonText}</button>
                )}
                {buttonText && (
                    <button className="nav-popup-btn" onClick={handleClick}>{buttonText}</button>
                )}
            </div>
        </div>
    );
};

export default AlertPopUp;
